import { render, staticRenderFns } from "./SettingsButton.vue?vue&type=template&id=cde8192a&scoped=true"
import script from "./SettingsButton.vue?vue&type=script&lang=js"
export * from "./SettingsButton.vue?vue&type=script&lang=js"
import style0 from "./SettingsButton.vue?vue&type=style&index=0&id=cde8192a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde8192a",
  null
  
)

export default component.exports